// Caret helpers for contentEditable text that holds plain text only.

export function caretOffset(el: HTMLElement): number | null {
  const sel = window.getSelection();
  if (!sel || sel.rangeCount === 0 || !sel.isCollapsed) return null;
  const range = sel.getRangeAt(0);
  if (!el.contains(range.startContainer)) return null;
  const pre = range.cloneRange();
  pre.selectNodeContents(el);
  pre.setEnd(range.startContainer, range.startOffset);
  return pre.toString().length;
}

export function selectionInside(el: HTMLElement): boolean {
  const sel = window.getSelection();
  if (!sel || sel.rangeCount === 0) return false;
  return el.contains(sel.getRangeAt(0).startContainer);
}

export function setCaret(el: HTMLElement, offset: number): void {
  const text = el.textContent ?? "";
  const target = Math.max(0, Math.min(offset, text.length));
  const range = document.createRange();
  let remaining = target;
  let placed = false;
  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
  let node = walker.nextNode();
  while (node) {
    const len = node.textContent?.length ?? 0;
    if (remaining <= len) {
      range.setStart(node, remaining);
      placed = true;
      break;
    }
    remaining -= len;
    node = walker.nextNode();
  }
  if (!placed) range.setStart(el, el.childNodes.length);
  range.collapse(true);
  const sel = window.getSelection();
  sel?.removeAllRanges();
  sel?.addRange(range);
}

/** Whether the caret sits on the first (or last) wrapped line of the
 *  element, which is when ArrowUp/Down should leave it. */
export function caretOnEdgeLine(el: HTMLElement, edge: "first" | "last"): boolean {
  const sel = window.getSelection();
  if (!sel || sel.rangeCount === 0) return true;
  const range = sel.getRangeAt(0).cloneRange();
  range.collapse(edge === "first");
  const rects = range.getClientRects();
  const rect = rects.length > 0 ? rects[0]! : null;
  if (!rect || rect.height === 0) return true;
  const box = el.getBoundingClientRect();
  const lineH = rect.height || 16;
  return edge === "first" ? rect.top - box.top < lineH * 0.5 : box.bottom - rect.bottom < lineH * 0.5;
}
